import { SG_COUNTRY_ID, ID_COUNTRY_ID, PH_COUNTRY_ID, HK_COUNTRY_ID } from './countries';
export const HARD_CODE_ORDER_COUNTRY = {
  [SG_COUNTRY_ID]: {
    109: 1,
    53: 2,
    113: 3,
    92: 4,
    117: 5,
  },
  [ID_COUNTRY_ID]: {
    114: 1,
    109: 2,
    102: 3,
    113: 4,
    88: 5,
    92: 6,
    117: 7,
  },
  [PH_COUNTRY_ID]: {
    120: 1,
    56: 2,
    109: 3,
    102: 4,
    113: 5,
    92: 6,
    117: 7,
  },
  [HK_COUNTRY_ID]: {
    84: 1,
    121: 2,
    89: 3,
    102: 4,
    92: 5,
    117: 6,
  },
};
